import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showShortcuts, setShowShortcuts] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Don't fire in input/textarea
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      }

      const mod = e.metaKey || e.ctrlKey;

      // Cmd+, -> Settings
      if (mod && e.key === ',') {
        e.preventDefault();
        navigate('/settings');
        return;
      }

      // Strg+O, Strg+U und Strg+D sind ersatzlos weg (Task 13). Sie warfen auf
      // `/` je ein CustomEvent (cmd:optimize / cmd:upload / cmd:fetch), auf das
      // seit dem Umbau der Startseite kein Empfaenger mehr hoert. Wirkungslos
      // waere schon schlecht genug; sie haben zusaetzlich per preventDefault
      // drei Browser-Kuerzel auf genau dieser Seite geschluckt. Wer sie
      // zurueckholt, braucht zuerst einen Empfaenger.

      // ? -> Show shortcuts dialog
      if (e.key === '?' && !mod) {
        e.preventDefault();
        setShowShortcuts(true);
        return;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [navigate, location.pathname]);

  return { showShortcuts, setShowShortcuts };
}
